import ResponsiveContainer from '../../common/ResponsiveContainer';

const Reglas = () => {
  return (
    <ResponsiveContainer className='font-montserrat mt-6 md:px-5'>
      <div className='bg-white rounded-xl shadow p-6 md:p-10'>

        <h1 className='font-bold text-2xl md:text-3xl text-darkred uppercase tracking-wide'>
          Reglas del Sitio
        </h1>
        <hr className='border-gray-300 mt-3 mb-6' />

        <p className='text-gray-700 leading-relaxed mb-4'>
          Somos <strong>Chabela y María Paz</strong>, traducimos y subtitulamos series turcas, somos unas
          apasionadas de esta cultura y esta forma diferente de contar historias, esperamos que disfruten
          en este sitio de lo que hacemos, tanto como nosotras disfrutamos traduciendo estas series.
        </p>

        <p className='text-gray-700 leading-relaxed mb-4'>
          Para <strong>proteger nuestro grupo y sus contenidos</strong>, queremos que todos lean las
          siguientes <strong>reglas</strong>.
        </p>

        <ul className='list-disc list-outside pl-5 space-y-3 text-gray-700 mb-6'>
          <li className='leading-relaxed'>
            Este grupo funciona en base a <strong>donaciones mensuales</strong>, por esta razón es
            fundamental su aporte para mantener el sitio web.
          </li>
          <li className='leading-relaxed'>
            Está <strong>prohibido compartir</strong> cualquier material de este grupo en otros grupos.
          </li>
          <li className='leading-relaxed'>
            No se puede recomendar a otros grupos o sitios web, tampoco recomendar links.
          </li>
          <li className='leading-relaxed'>
            Para no tener problemas de Copyright no se aceptarán comentarios ni publicaciones con &ldquo;#&rdquo;
          </li>
        </ul>

        <p className='text-gray-700 leading-relaxed'>
          Las reglas las creamos para <strong>cumplirlas</strong>, lamentablemente quien no las cumpla
          tendrá que ser <strong>bloqueados del grupo.</strong>
        </p>

        <p className='font-pacifico text-3xl text-gray-700 mt-12'>Turkish4Love</p>
      </div>
    </ResponsiveContainer>
  );
};

export default Reglas;
